<div class="icon-wrapper">
    <div class="icon linkedin" (click)="shareLinkedIn()"></div>
    <div class="icon twitter" (click)="shareTwitter()"></div>
    <div class="icon facebook" (click)="shareFacebook()"></div>
</div>